import React, { useEffect, useState, useCallback } from 'react';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import { CompetitionForm, CompetitionResultForm, CompetitionTabpanel, FormPopup } from '../../components';
import { withLoadPanel } from '../../utils/withLoadPanel';
import './competition_edit.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiToken } from '../../utils/authUtils.js';
import notify from 'devextreme/ui/notify';
import { useMsal } from "@azure/msal-react";
import { confirm } from 'devextreme/ui/dialog';

export const CompetitionDetails = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();

    const [isLoading, setIsLoading] = useState(false);
    const [isdsvLoading, setisdsvLoading] = useState(false);
    const CompetitionFormWithLoadPanel = withLoadPanel(CompetitionForm);
    const CompetitionResultFormWithLoadPanel = withLoadPanel(CompetitionResultForm);
    const CompetitionTabpanelWithLoadPanel = withLoadPanel(CompetitionTabpanel);
    const [popupVisible, setPopupVisible] = useState(false);
    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);
    const [popupEntriesVisible, setPopupEntriesVisible] = useState(false);
    const changePopupEntriesVisibility = useCallback((isVisble) => {
        setPopupEntriesVisible(isVisble);
    }, []);
    const [popupStartlistVisible, setPopupStartlistVisible] = useState(false);
    const changePopupStartlistVisibility = useCallback((isVisble) => {
        setPopupStartlistVisible(isVisble);
    }, []);


    var { competitionId } = useParams()
    const navigate = useNavigate();

    const onLeftClick = () => {
        navigate(-1);
    };
    const onActionDropDownClick = (e) => {
        switch (e.itemData) {
            case 'Ergebnisse importieren':
                setPopupVisible(true);
                break;
            case 'Meldungen importieren':
                setPopupEntriesVisible(true);
                break;
            case 'Startliste importieren':
                setPopupStartlistVisible(true);
                break;
            case 'Meldungen löschen':
                confirm('Sind Sie sicher, dass Sie alle Meldungen löschen möchten?', 'Bestätigung')
                    .then((dialogResult) => {
                        if (dialogResult) {
                            getApiToken(instance, accounts).then(token => {
                                fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/DeleteAllEntries?competitionId=${competitionId}`, {
                                    method: 'DELETE',
                                    headers: {
                                        'Authorization': "Bearer " + token
                                    }
                                })
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.success) {
                                            notify({
                                                message: `${data.result_set} Meldungen erfolgreich gelöscht`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'success');
                                            refresh();
                                        } else {
                                            notify({
                                                message: `Fehler beim Löschen der Meldungen: ${data.userMessage || 'Unbekannter Fehler'}`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'error');
                                        }
                                    })
                                    .catch(error => {
                                        notify({
                                            message: `Fehler beim Löschen der Meldungen: ${error.userMessage || 'Unbekannter Fehler'}`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'error');
                                    });
                            });
                        }
                    });
                break;

            case 'Ergebnisse löschen':
                confirm('Sind Sie sicher, dass Sie alle Ergebnisse löschen möchten?', 'Bestätigung')
                    .then((dialogResult) => {
                        if (dialogResult) {
                            getApiToken(instance, accounts).then(token => {
                                fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/DeleteAllResults?competitionId=${competitionId}`, {
                                    method: 'DELETE',
                                    headers: {
                                        'Authorization': "Bearer " + token
                                    }
                                })
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.success) {
                                            notify({
                                                message: `${data.result_set} Ergebnisse erfolgreich gelöscht`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'success');
                                            refresh();
                                        } else {
                                            notify({
                                                message: `Fehler beim Löschen der Ergebnisse: ${data.userMessage || 'Unbekannter Fehler'}`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'error');
                                        }
                                    })
                                    .catch(error => {
                                        notify({
                                            message: `Fehler beim Löschen der Ergebnisse: ${error.userMessage || 'Unbekannter Fehler'}`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'error');
                                    });
                            });
                        }
                    });
                break;

            case 'Wettkampf löschen':
                confirm('Sind Sie sicher, dass Sie den Wettkampf löschen möchten?', 'Bestätigung')
                    .then((dialogResult) => {
                        if (dialogResult) {
                            getApiToken(instance, accounts).then(token => {
                                fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/DeleteCompetition?competitionId=${competitionId}`, {
                                    method: 'DELETE',
                                    headers: {
                                        'Authorization': "Bearer " + token
                                    }
                                })
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.success) {
                                            notify({
                                                message: `Wettkampf erfolgreich gelöscht`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'success');
                                            navigate(-1);
                                        } else {
                                            notify({
                                                message: `Fehler beim Löschen des Wettkampfs: ${data.userMessage || 'Unbekannter Fehler'}`,
                                                position: { at: 'bottom center', my: 'bottom center' }
                                            }, 'error');
                                        }
                                    })
                                    .catch(error => {
                                        notify({
                                            message: `Fehler beim Löschen des Wettkampfs: ${error.userMessage || 'Unbekannter Fehler'}`,
                                            position: { at: 'bottom center', my: 'bottom center' }
                                        }, 'error');
                                    });
                            });
                        }
                    });
                break;

            case 'Meldungen versenden':
                navigate(`/competition/entrysend/${competitionId}`);
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        loadData();
    }, []);
    const onResultsFileChanged = useCallback((e) => {
        setisdsvLoading(true);
        getApiToken(instance, accounts).then(token => {
            const formData = new FormData();
            formData.append('file', e[0]);
            formData.append('competitionId', competitionId);

            fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/ImportResults`, {
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + token
                },
                body: formData

            })
                .then(response => response.json())
                .then(data => {

                    if (data.success) {
                        notify({
                            message: `${data.result_set} Ergebnisse erfolgreich hochgeladen`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'success');
                        refresh();


                        setPopupVisible(false);
                    } else {
                        notify({
                            message: `Fehler beim Hochladen der Datei: ${data.userMessage || 'Unbekannter Fehler'}`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'error');
                    }
                    setisdsvLoading(false);

                })
                .catch(error => {
                    setisdsvLoading(false);
                    notify({
                        message: `Fehler beim Hochladen der Datei: ${error.userMessage || 'Unbekannter Fehler'}`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    }, 'error');
                });

        });
    }, []);
    const onEntriesFileChanged = useCallback((e) => {
        setisdsvLoading(true);
        getApiToken(instance, accounts).then(token => {
            const formData = new FormData();
            formData.append('file', e[0]);

            fetch(`${process.env.REACT_APP_serverEndpoint}/Competition/ImportEntries`, {
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + token
                },
                body: formData

            })
                .then(response => response.json())
                .then(data => {

                    if (data.success) {
                        notify({
                            message: `${data.result_set} Meldungen erfolgreich hochgeladen`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'success');
                        refresh();


                        setPopupVisible(false);
                    } else {
                        notify({
                            message: `Fehler beim Hochladen der Datei: ${data.userMessage || 'Unbekannter Fehler'}`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'error');
                    }
                    setisdsvLoading(false);

                })
                .catch(error => {
                    setisdsvLoading(false);
                    notify({
                        message: `Fehler beim Hochladen der Datei: ${error.userMessage || 'Unbekannter Fehler'}`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    }, 'error');
                });

        });
    }, []);
    const onLenexStartlistFileChanged = useCallback((e) => {
        setisdsvLoading(true);
        getApiToken(instance, accounts).then(token => {
            const formData = new FormData();
            formData.append('file', e[0]);
            formData.append('competitionId', competitionId);
            fetch(`${process.env.REACT_APP_serverEndpoint}/Entry/ImportStartlistLenex`, {
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + token
                },
                body: formData

            })
                .then(response => response.json())
                .then(data => {

                    if (data.success) {
                        notify({
                            message: `${data.result_set} Einträge erfolgreich aktualisiert`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'success');
                        refresh();


                        setPopupVisible(false);
                    } else {
                        notify({
                            message: `Fehler beim Hochladen der Datei: ${data.userMessage || 'Unbekannter Fehler'}`,
                            position: { at: 'bottom center', my: 'bottom center' }
                        }, 'error');
                    }
                    setisdsvLoading(false);

                })
                .catch(error => {
                    setisdsvLoading(false);
                    notify({
                        message: `Fehler beim Hochladen der Datei: ${error.userMessage || 'Unbekannter Fehler'}`,
                        position: { at: 'bottom center', my: 'bottom center' }
                    }, 'error');
                });

        });
    }, []);
    const loadData = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'competitionId',
                loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/Competitions`,
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/InsertCompetition`,
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/UpdateCompetition`,
                deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/DeleteCompetition`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            const dataSource_session = {
                store: createStore({
                    key: 'sessionId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Session/Sessions`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Session/InsertSession`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Session/UpdateSession`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Session/DeleteSession`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['competitionId', '=', competitionId]
            };
            var dataSource_user = {
                store: createStore({
                    key: 'userId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/User/UsersBasic`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                })
            };
            const dataSource_events = {
                store: createStore({
                    key: 'eventId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Event/Events`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Event/InsertEvent`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Event/UpdateEvent`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Event/DeleteEvent`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['competitionId', '=', competitionId]
            };

            const swimstylesDataSource =
                createStore({
                    key: 'swimstyleId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Swimstyle/Swimstyles`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                })
                ;
            const resultesDataSource = {
                store: createStore({
                    key: 'resultId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Result/ResultsView`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Result/InsertResult`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Result/UpdateResult`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Result/DeleteResult`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                    loadParams: { filter: [`[\"competitionId\",\"${competitionId}\"]`] }
                })
            };
            const resultesRelayDataSource = {
                store: createStore({
                    key: 'relayId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Result/ResultsRelayView`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Result/InsertRelayResult`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Result/UpdateRelayResult`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Result/DeleteRelayResult`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['competitionId', '=', competitionId]
            };
            const entriesDataSource = {
                store: createStore({
                    key: 'athleteId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/Entries`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/SetStatusEntry`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                    
                }), filter: ['competitionId', '=', competitionId]
            };
            const EntriesRelayDataSource = {
                store: createStore({
                    key: 'entryRelayId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/EntriesRelay`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                }), filter: ['competitionId', '=', competitionId]
            };
            const traininggroupsDataSource =
                createStore({
                    key: 'traininggroupId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Traininggroup/TraininggroupsBasic`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                });


            Promise.all([
                dataSource.load({ filter: ['competitionId', '=', competitionId] }),
                swimstylesDataSource.load(),
                traininggroupsDataSource.load({ select: ['groupname'] }),

            ]).then((values) => {
                setData({ competition: values[0][0], sessions: dataSource_session, events: dataSource_events, swimstyles: values[1], users: dataSource_user, results: resultesDataSource, resultsRelay: resultesRelayDataSource, entries: entriesDataSource, EntriesRelay: EntriesRelayDataSource, traininggroups: values[2] });
                setIsLoading(false);

            }).catch((error) => console.log(error));


        });

    }, []);

    const refresh = useCallback(() => {
        setIsLoading(true);
        loadData();
    }, []);
    const onSave = useCallback((data) => {
        getApiToken(instance, accounts).then(token => {
            const dataSource = createStore({
                key: 'competitionId',
                updateUrl: `${process.env.REACT_APP_serverEndpoint}/Competition/UpdateCompetition`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });
            dataSource.update(data.competitionId, data).then(() => {
                notify({
                    message: `Wettkampf "${data.competitionname}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'success'
                );
                refresh();
            }
            );
        })
    }, []);


    return (
        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-competition-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before'>
                        <div className='toolbar-title'>
                            {data ? data?.competition?.competitionname : 'Lädt...'}
                        </div>
                    </Item>
                    {/* <Item location='after' locateInMenu='auto'>
                        <Button
                            text='Meldungen hinzufügen/ändern'
                            type='default'
                            stylingMode='contained'
                            visible={data?.competition?.status === 'Meldung möglich'}
                        // onClick={() => setPopupVisible(true)}
                        />
                    </Item> */}

                    <Item location='after'>
                        <DropDownButton
                            text='Aktionen'
                            stylingMode='text'
                            dropDownOptions={{ width: 'auto' }}
                            items={['Meldungen versenden', 'Meldungen importieren', 'Startliste importieren', 'Ergebnisse importieren', 'Meldungen löschen', 'Ergebnisse löschen', 'Wettkampf löschen']}
                            onItemClick={onActionDropDownClick}
                        />
                    </Item>
                    <Item location='after' locateInMenu='auto'>
                        <div className='separator' />
                    </Item>
                    {/* <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Copy'
                            icon='copy'
                            stylingMode='text'
                        />
                    </Item> */}
                    <Item
                        location='after'
                        locateInMenu='auto'
                        widget='dxButton'
                        showText='inMenu'
                    >
                        <Button
                            text='Refresh'
                            icon='refresh'
                            stylingMode='text'
                            onClick={refresh}
                        />
                    </Item>
                </Toolbar>

                <div className='panels'>
                    <div className='left'>
                        <CompetitionFormWithLoadPanel
                            loading={isLoading}
                            hasData={!!data}
                            data={data}
                            onSave={onSave}
                        />
                    </div>

                    <div className='right'>
                        <div className='dx-card details-card'>
                            <CompetitionTabpanelWithLoadPanel
                                loading={isLoading}
                                hasData={!!data}
                                data={data}
                                competitionId={competitionId}
                                onSave={onSave}
                            />
                        </div>
                    </div>
                </div>
                <FormPopup title='Wettkampfergebnisse' visible={popupVisible} setVisible={changePopupVisibility} isSaveVisible={false}>
                    <CompetitionResultFormWithLoadPanel hasData={true} loading={isdsvLoading} initData={{}} onFileChanged={onResultsFileChanged} fileType="AUTO" />
                </FormPopup>
                <FormPopup title='Wettkampfmeldungen' visible={popupEntriesVisible} setVisible={changePopupEntriesVisibility} isSaveVisible={false}>
                    <CompetitionResultFormWithLoadPanel hasData={true} loading={isdsvLoading} initData={{}} onFileChanged={onEntriesFileChanged} fileType="AUTO" />
                </FormPopup>
                <FormPopup title='Startliste/Meldeergebnis' visible={popupStartlistVisible} setVisible={changePopupStartlistVisibility} isSaveVisible={false}>
                    <CompetitionResultFormWithLoadPanel hasData={true} loading={isdsvLoading} initData={{}} onFileChanged={onLenexStartlistFileChanged} fileType="LENEX" />
                </FormPopup>

            </div>
        </ScrollView>
    );
};


